<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Monitoramento de processos' | translate}}
    </div>
</div>

<main class="container">
    <h1>{{ 'Monitoramento de processos' | translate}}</h1>

    <div class="filtros">
        <div class="filtro">
            <label for="pais">{{ 'País' | translate}}</label>
            <select id="pais" [(ngModel)]="filtro.pais">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.countryCode">{{pais.name}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="processo">{{ 'Processo' | translate}}</label>
            <select id="processo" [(ngModel)]="filtro.processo">
                <option value="">{{ 'Todos' | translate}}</option>
                <option value="Import">Import FTP</option>
                <option value="Maestro">{{ 'Validação Maestro' | translate}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status">{{ 'Status' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.status">
                <option value="">{{ 'Todos' | translate}}</option>
                <option value="Rodando">{{ 'Rodando' | translate}}</option>
                <option value="Ocioso">{{ 'Ocioso' | translate}}</option>
                <option value="Travado">{{ 'Travado' | translate}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="intervalo">{{ 'Atualizar a cada' | translate}}</label>
            <select id="intervalo" [(ngModel)]="filtro.intervaloMin" (change)="reiniciarAutoRefresh()">
                <option [value]="1">1 min</option>
                <option [value]="10">10 min</option>
                <option [value]="30">30 min</option>
            </select>
        </div>
        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="consultar()" class="red_button">{{ 'Consultar' | translate }}</button>
        </div>
        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="limparFiltro()" class="clear-button">{{ 'Limpar Filtros' | translate}}</button>
        </div>
    </div>

    <p class="atualizado-em" *ngIf="atualizadoEm">
        {{ 'Atualizado em' | translate}}: {{atualizadoEm | date:'dd/MM/yyyy HH:mm:ss'}}
    </p>

    <div class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>{{ 'País' | translate}}</th>
                    <th>{{ 'Processo' | translate}}</th>
                    <th>{{ 'Status' | translate}}</th>
                    <th>{{ 'Travado há' | translate}}</th>
                    <th>{{ 'Pendentes' | translate}}</th>
                    <th>{{ 'Detalhe' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let linha of listaLinhas">
                    <td>{{linha.countryName}}</td>
                    <td>{{linha.processo}}</td>
                    <td><span class="status-badge" [ngClass]="statusClass(linha.status)">{{linha.status | translate}}</span></td>
                    <td>{{linha.travadoHaMinutos ? (linha.travadoHaMinutos | number:'1.0-0') + ' min' : '-'}}</td>
                    <td>{{linha.pendentes}}</td>
                    <td>{{linha.detalhe}}</td>
                </tr>
                <tr *ngIf="listaLinhas.length === 0">
                    <td colspan="6" class="text-center">{{ 'Nenhum processo encontrado.' | translate}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</main>
